const en = {
  common: {
    create: `Create`,
    requestRegulation: 'Request Regulation',
    save: `Save`,
    add: `Add`,
    edit: `Edit`,
    open: `Open`,
    moreDetails: `More Details`,
    editNewTab: `Edit in a new tab`,
    openNewTab: `Open in a new tab`,
    delete: `Delete`,
    deleting: `Deleting`,
    details: `Details`,
    download: 'Download',
    downloadStart: 'Download will start any second',
    downloadError: 'Error trying to download file',
    cancel: `Cancel`,
    createSuccess: `Create success!`,
    requestSuccess: 'Request success!',
    updateSuccess: `Update success!`,
    deleteSuccess: `Delete success!`,
    fieldRequired: `This field is required`,
    goBack: `Go Back`,
    upload: `Upload`,
    home: `Home`,
    confirm_delete_message: 'Are you sure you want to delete?',
    positiveIntegerErrorMsg: 'This field should be a positive integer number',
    invalidDate: 'Invalid Date',
    invalidCredentials: 'Invalid email address or password',
    missingPermissions: "You don't have the required permissions to access this site",
    signIn: 'Sign in',
    preview: 'Preview',
    newexport: 'New Export',
    newalert: 'New Alert',
    none: 'None',
    requestError: 'An error occurred while processing request. Please try again later.',
    login: 'Login',
    search: 'Search...',
    searchBy: 'Search by',
    sortBy: 'Sort by',
    selectRelease: 'Select Release',
    referenceTo: 'reference to',
    dependencyTo: 'dependency to',
    createDraft: 'Create Draft',
    createNewVersion: 'Create Version',
    createDraftSuccess: 'Draft created successfully!',
    draftAlreadyExists: 'Draft already exists',
    errorNotDraft: 'Only drafts can be modified',
    newVersionAlreadyExists: 'New unreleased version already exists',
    tags: 'Tags',
    publish: 'Publish',
    azureLoginButton: 'Login with Azure',
    keycloakLoginButton: 'Login with Keycloak',
    or: 'or',
    legalNotice: 'Legal Notice',
    impressum: 'Impressum',
    copyright: 'Copyright',
    kontrolTitle: 'Kontrol.tech',
    versions: 'Versions',
    view: 'View',
    requirements: 'Requirements',
    validate: 'Validate',
    yes: 'Yes',
    no: 'No',
    submit: 'Submit',
    confirm: 'Confirm',
    noData: 'No available data',
    send: 'Send',
    content: 'Content',
    properties: 'Properties',
  },
  legalProvisionAssignments: {
    manageAccess: 'Manage Access',
    assignmentPageTitle: 'Manage Legal Provision Access',
    userGroup: 'User Group',
  },
  diffViewer: {
    toggleDiff: 'Toggle diff',
    toggleViewCurrent: 'Change view. Current:',
    changeGutter: 'Change gutter',
    newVersion: 'Compare version',
    oldVersion: 'Base version',
  },
  delta: {
    title: 'Delta',
    showOnlyUpdatedParagraphs: 'Show only updated paragraphs',
    updateDeltaView: 'Compare',
    selectForCompare: {
      baseLegalProvision: 'Base Legal Provision',
      compareLegalProvision: 'Compare Legal Provision',
      showMoreDetails: 'Show more options',
      showLessDetails: 'Show less options',
      selectLegalProvision: 'Select Legal Provision',
      selectVersion: 'Select Version',
      selectRelease: 'Select Release',
    },
    legalProvisions: {
      title: 'Delta - Legal Provisions',
      menu: {
        documentElementMoving: 'Track Movement',
      },
    },
    documentElements: {
      title: 'Delta - Document Element Moving',
      moving: {
        title: 'Delta - Document Element Moving',
      },
    },
  },
  landingPage: {
    title: 'Legislation Overview',
    newLegislation: 'New Legislation',
    requestLegislation: 'Request Regulation',
    legislationItems: {
      version: 'Version:',
      versionId: 'Version ID:',
      validity: 'Validity:',
      validityFromTo: '{{from}} to {{to}}',
      issueDate: 'Date of Issue:',
      source: 'Source:',
      sourceName: 'Source Name:',
      tags: 'Tags:',
      publisher: 'Publisher:',
      versionTimestamp: 'Version Timestamp:',
      releaseTimestamp: 'Release Timestamp:',
      type: 'Type:',
    },
  },
  navConfig: {
    dashboard: 'DASHBOARD',
    legalProvision: 'LEGAL PROVISION',
    details: 'Details',
  },
  userAccount: {
    title: 'User Account',
    notifications: {
      changePasswordSuccess: 'Password changed successfully',
      changePasswordError: 'Error: changing password failed',
    },
    changePass: {
      validation: {
        requiredNew: 'New password is required',
        requiredOld: 'Old password is required',
        passLength: 'Password must be at least 6 characters long',
        mustMatch: 'Passwords must match',
        beDifferent: 'New password must be different from old password',
      },
      labels: {
        oldPassword: 'Old password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
      },
    },
  },
  legalProvisions: {
    country: `Country`,
    countryFlag: 'Country Flag',
    header: `Legal Provisions`,
    createPageTitle: `Create Legal Provision`,
    requestPageTitle: 'Request Regulation',
    editPageTitle: `Edit Legal Provision`,
    newVersionPageTitle: `Create Legal Provision Version`,
    detailsPageTitle: `Legal Provision Details`,
    fullName: `Full Name`,
    legalProvision: `Legal Provision`,
    abbreviation: `Abbreviation`,
    version: `Version`,
    validFrom: `Valid From`,
    validFromRaw: 'Valid From (Raw)',
    validTo: `Valid To`,
    validToRaw: 'Valid To (Raw)',
    dateOfPublication: `Date Of Publication`,
    dateOfPublicationRaw: 'Date Of Publication (Raw)',
    dateOfAdoption: `Date Of Adoption`,
    publisher: `Publisher`,
    type: `Type`,
    sourceName: `Source Name`,
    sourceLink: `Source Link`,
    isComplete: `Is Complete`,
    errorAbbreviationAlreadyTaken: 'Legal Provision with provided abbreviation already exists.',
    versionName: 'Version',
    versionId: 'Version ID',
    versionTimestamp: 'Version Date',
    releaseId: 'Release ID',
    releaseName: 'Release',
    releaseTimestamp: 'Release Date',
    releaseNotes: 'Release Notes',
    other: 'Other',
    notes: 'Notes:',
    lang: 'Language',
    translationType: 'Translation',
    addTranslation: 'Add Translation',
    dialog: {
      title: 'Confirm Change Field',
      warningMsg: 'The following fields were changed, are you sure you want to save the changes?',
    },
    translationExists: 'Translation already exists',
    translationRequested: 'Translation is requested',
    legalProvisionContent: 'Digitization Type',
    status: 'Status',
    summary: 'Summary',
    summaryOfChanges: 'Summary of Changes',
    detailsBox: {
      title: 'Details',
      version: 'Official Version:',
      versionId: 'Version ID:',
      validity: 'Validity:',
      validityFromTo: '{{from}} to {{to}}',
      issueDate: 'Date of Publication:',
      adoptionData: 'Date of Adoption:',
      source: 'Source:',
      sourceName: 'Source Name:',
      tags: 'Tags:',
      publisher: 'Publisher:',
      releaseNotes: 'Kontrol Release Notes:',
      notes: 'Notes:',
      disclaimer: {
        title: 'Disclaimer:',
        main: 'Please note that the translations of legal, technical and regulatory texts available on this website are generated through artificial intelligence. While we strive to ensure the accuracy and reliability of these translations, they may contain errors and should not be considered equivalent to professionally certified translations. We recommend consulting the texts in original language or seeking professional advice when accuracy is critical. Your use of these translations is at your own risk, and we do not accept liability for any inaccuracies or misunderstandings that may arise from their use.',
        bottom: 'Thank you for your understanding.',
      },
    },
    deltaPage: {
      newBoxTitle: 'New version details',
      oldBoxTitle: 'Old version details',
      noPreviousVersion: 'No previous version to compare',
    },
    tableOfContents: {
      title: 'Table of Contents',
      expandAll: 'Expand All',
      collapseAll: 'Collapse All',
    },
    translationPage: {
      header: 'Translation',
      selectTranslation: 'Select Language',
      originalTitle: 'Original language details',
      translationTitle: 'Translation language details',
      addTranslation: 'Add Language',
      requestTranslation: 'Request Translation',
      editTranslation: 'Edit Translation',
      selectDocumentElementFields: 'Select Fields:',
      translationStatus: {
        title: 'Translation Status',
        completed: 'Complete',
        inProgress: 'In Progress',
        notStarted: 'Not Started',
        failed: 'Failed',
      },
      sendFailed: 'Send Failed',
      resend: 'Resend',
      sendSuccess: 'Translation sent successfully',
      sendError: 'Error sending translation, please try again later',
      dialogs: {
        newTranslation: {
          title: 'Confirm request for new translation',
          message: 'Are you sure you want to request a new translation?',
        },
        resend: {
          title: 'Confirm resend translation request',
          message: 'Are you sure you want to resend the translation request?',
        },
      },
    },
    attachment: {
      addAttachments: 'Add attachments',
      updateAttachment: 'Edit attachment',
      attachmentCreated: 'Attachment created successfully',
      attachmentUpdated: 'Attachment updated successfully',
    },
    selectDocumentElement: 'Select Document Element(s) for deletion',
    selectForDeletion: 'Bulk deletion',
  },
  documentElements: {
    header: `Document Element`,
    createPageTitle: `Create Document Element`,
    editPageTitle: `Edit Document Element`,
    viewPageTitle: `View Document Element`,
    officialParagraphNumber: `Official Paragraph Number`,
    title: `Title`,
    order: `Order`,
    mainBody: `Main Body`,
    validFrom: `Valid From`,
    validTo: `Valid To`,
    child: `Child of`,
    addChild: `Add Child Element`,
    sibling: `Sibling of`,
    addSibling: `Add Sibling Element`,
    backToGeneralSearch: `Back to search`,
    tooltipEdit: `Edit element`,
    moveTo: `Move To`,
    moveInto: `Move Into`,
    moveIntoIssue: `Some or all elements not moved, please try again`,
    selectNewParent: `Select a new parent element`,
    selectElements: 'Select elements',
    allCategories: `All Categories`,
  },
  files: {
    title: `Files`,
    filesUploaded: 'Files uploaded succesfully',
    fileDeleted: 'File deleted succesfully',
    files: 'Files',
    fileDownloadError: 'File download error',
    addFile: 'Add File',
  },
  legalReferences: {
    headerFrom: `References`,
    headerTo: `Referenced by`,
    dialogHeader: `Edit Reference`,
    type: `Type`,
    reasoning: `Reasoning`,
    paragraph: `Paragraph`,
    title: `Title`,
    mainBody: `Main Body`,
    sourceOfficialParagraphNumber: `Paragraph Number`,
    sourceTitle: `Title`,
    sourceMainBody: `Source Main Body`,
    targetOfficialParagraphNumber: `Paragraph Number`,
    targetTitle: `Title`,
    targetMainBody: `Target Main Body`,
    legalProvision: `Legal Provision`,
    targetDocument: 'Document Element',
    openDocument: 'Open',
  },
  sentenceFragments: {
    header: `Sentence Fragments`,
    add: `Add Sentence Fragment`,
    child: `child`,
    edit: `Edit Sentence Fragment`,
    text: `Text`,
    notes: `Notes`,
    usageType: `Usage Type`,
    decompositionType: `Decomposition Type`,
    questionType: `Question Type`,
    sentenceTypeRequired: `Usage Type or Decomposition Type required`,
    usageTypeEnum: {
      logic: `Logic`,
      property: `Property`,
      object: `Object`,
    },
    decompositionTypeEnum: {
      condition: `Condition`,
      subject: `Subject`,
      action: `Action`,
    },
    questionTypeEnum: {
      whoIsAffected: 'Who is affected?',
      whatIsPrescribedProhibited: 'What is prescribed/prohibited?',
      location: 'Location',
      time: 'Time',
      vehicle: 'Vehicle',
      environment: 'Environment',
      belongsToWhichSign: 'Belongs to which sign?',
    },
  },
  legalRequirements: {
    header: `Legal Requirements`,
    createPageTitle: `Create Legal Requirement`,
    editPageTitle: `Legal Requirement`,
    name: `Name`,
    mainBody: `Main Body`,
    reason: `Reason`,
    type: `Type`,
    reasonForType: `Reason for Type`,
    notes: `Notes`,
    errorNameAlreadyTaken: 'Legal Requirement with provided name already exists.',
    split: 'Split Legal Requirement',
    details: 'Requirement Details',
  },
  legalRequirementSources: {
    header: `Sources`,
    dialogHeader: `Edit Legal Requirement Source`,
    isMain: `Is Main`,
    usedText: `Used Text`,
    reasoning: `Reasoning`,
    legalProvision: `Legal Provision`,
    documentElement: `Document Element`,
    documentElementParagraph: `Paragraph Number`,
    documentElementTitle: `Title`,

    mainBody: `Main Body`,
    reason: `Reason`,
    type: `Type`,
    reasonForType: `Reason for Type`,
    notes: `Notes`,
    errorNameAlreadyTaken: 'Legal Requirement with provided name already exists.',
  },
  properties: {
    header: `Properties`,
    createPageTitle: `Create Property`,
    editPageTitle: `Edit Property`,
    name: `Name`,
    questionAsked: `Question Asked`,
    description: `Description`,
    inputsDescription: `Inputs Description`,
    reasoningAndDefinition: `Reasoning & Definition`,
    futureImplementation: `Future Implementation`,
    mathematicalFormulation: `Mathematical Formulation`,
    errorNameAlreadyTaken: 'Property with provided name already exists.',
  },
  legalRadar: {
    header: `Legal Radar`,
    boxNews: `Box News`,
    warning: 'This text will be displayed in all Customer User Interfaces after Saving.',
    form: {
      maxCharacters: 'Max 500 characters',
    },
  },
  technicalRequirements: {
    header: `Technical Requirements`,
    createPageTitle: `Create Technical Requirement`,
    editPageTitle: `Edit Technical Requirement`,
    startNew: 'Start New Technical Requirement',
    name: 'Name',
    conditions: 'Conditions',
    directives: 'Directives',
    verbalRepresentation: 'Verbal Representation',
    logicalRepresentation: 'Logical Representation',
    ruleName: 'Rule Name',
    comment: 'Comment',
    formula: 'Formula',
    errorNameAlreadyTaken: 'Technical Requirement with provided name already exists.',
    overlappedGroups: 'Names of groups are overlapping',
  },
  technicalRequirementSources: {
    header: `Source Legal Requirements`,
    dialogHeader: `Edit Technical Requirement Source`,
    isMain: `Is Main`,
    reasoning: `Reasoning`,
    legalRequirement: `Legal Requirement`,
    legalRequirementName: `Name`,
    mainBody: `Main Body`,
  },
  dependencies: {
    deDependenciesHeader: `Document Element Dependencies`,
    lrDependenciesHeader: `Legal Requirement Dependencies`,
    documentElementParagraphNumber: `Official Paragraph Number`,
    documentElementTitle: `Title`,
    legalRequirementName: `Name`,
    dialogHeader: `Edit Dependency`,
    openDocument: 'Open',
    reasoning: `Reasoning`,
    type: `Type`,
    legalProvision: `Legal Provision`,
    targetDocument: 'Target Document Element',
    targetLegalRequirement: 'Target Legal Requirement',
    mainBody: 'Main Body',
  },
  tagGroups: {
    header: `Tag Group Configuration`,
    createPageTitle: `Create Tag Group`,
    editPageTitle: `Edit Tag Group`,
    name: `Name`,
    isPublic: `Is Public`,
    errorNameAlreadyTaken: 'Tag Group with provided name already exists.',
  },
  tags: {
    header: `Tag Configuration`,
    createPageTitle: `Create Tag`,
    editPageTitle: `Edit Tag`,
    name: `Name`,
    description: `Description`,
    tagGroup: `Tag Group`,
    errorNameAlreadyTaken: 'Tag with provided name already exists in provided tag group.',
  },
  sentenceFragmentsGroup: {
    header: `Sentence Fragments Groups`,
    add: `Add Sentence Fragments Group`,
    edit: `Edit Sentence Fragments Group`,
    name: `Name`,
    type: `Type`,
    isPropertyAttached: `Is Property Attached`,
    typeEnum: {
      directive: `Directive`,
      condition: `Condition`,
    },
    legalRequirementName: `Legal Requirement`,
    usedSentenceFragments: `Used sentence fragments`,
    propertyName: `Property`,
    exactlyOnePropertyError: `Group must contain exactly one sentence fragment with Usage Type - Property`,
    createSentenceFragmentGroup: `Create Group`,
    errorNameAlreadyTaken:
      'Sentence Fragment with provided name already exists for this Technical Requirement.',
    errorPropertyAlreadyTaken: 'Given property is already used in this Technical Requirement.',
  },
  releases: {
    createPageTitle: `Create New Release`,
    changeLogExternal: `External change log`,
    changeLogInternal: `Internal change log`,
    noRelease: `[No release]`,
  },
  inputs: {
    header: 'Inputs',
    createPageTitle: 'Create Input',
    editPageTitle: 'Edit Input',
    name: 'Name',
    inputType: 'Input Type',
    dataType: 'Data Type',
    description: 'Description',
    errorNameAlreadyTaken: 'Input with provided name already exists.',
    errorInUse: "Input is used and can't be deleted",
    assignInputs: 'Assign Inputs',
    inputTypeValues: {
      interface: 'Interface',
      parameter: 'Parameter',
      file: 'File',
    },
    dataTypeValues: {
      boolean: 'Boolean',
      number: 'Number',
      object: 'Object',
      other: 'Other',
    },
  },
  versions: {
    versionName: 'Version',
    versionDate: 'Version Date',
    releaseDate: 'Release Date',
  },
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  exports: {
    description: 'Description',
    download: 'Download',
    createPageTitle: 'New Export',
    editPageTitle: 'Edit Export',
    header: 'Exports',
    selected: 'Selected',
    name: 'Export Name',
    format: 'Format',
    createdAt: 'Created At',
    messages: {
      exportFailed: 'Export failed. Please try again.',
      exportSuccess: 'Export successful. Download will start shortly.',
    },
  },
  reports: {
    header: 'Reports',
    subHeader: 'SIMULATION',
    name: 'Report Name',
    createdAt: 'Created At',
  },
  import: {
    header: 'Import',
    createPageTitle: 'Import',
    scenarios: 'Choose scenarios to upload',
    assets: 'Choose assets to upload',
  },
  alerts: {
    header: 'Alerts',
    name: 'Alert',
    time: 'Date of Alert',
    createdAt: 'Created At',
    userGroupId: 'User Group',
    createPageTitle: 'New Alert',
    editPageTitle: 'Alert',
    selected: 'Selected',
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  regulations: {
    page: {
      header: 'Regulations',
      title: 'Regulation Overview',
    },
    select: {
      title: 'Select Regulation',
    },
    list: {
      title: 'Regulation List',
      assignedTo: 'Legal Provisions for User Group',
      selectGroup: 'Select a group to view legal provisions',
    },
    assignedTo: 'Legal Provision for User Group',
    assignLegalProvisions: 'Assign Legal Provisions',
    selectRegulation: 'Select Legal Provision',
    selectVersion: 'Select Version',
    selectRelease: 'Select Release',
    properties: {
      page: {
        header: 'Regulation Properties',
      },
    },
    content: {
      page: {
        header: 'Regulation Content',
      },
    },
  },
  admins: {
    page: {
      header: 'Admin',
    },
  },
  userGroups: {
    list: 'User Groups',
    properties: {
      id: 'ID',
      name: 'Name',
      hasInternal: 'Has Internal Access',
      hasExternal: 'Has External Access',
      hasLegalRequirements: 'Has Legal Requirements Access',
    },
  },
  users: {
    list: {
      inGroup: 'Users in Group',
      selectGroup: 'Select a group to view users',
    },

    properties: {
      fullName: 'Full Name',
      login: 'Login',
      userType: 'User Type',
      firstName: 'First Name',
      lastName: 'Last Name',
    },

    profile: {
      page: {
        header: 'User Profile',
        error: 'Error loading user profile',
      },
    },
  },
  integration: {
    header: 'Integration',
    page: {
      header: 'Integration',
      error: 'Error loading integration',
    },
    search: {
      externalDocument: {
        view: 'View External Document',
        commonTab: 'Details',
        additionalTab: 'Raw Data',
      },
      list: {
        resultsHeader: 'Search Results',
        id: 'ID',
        documentNumber: 'Document Number',
        titleEn: 'Title (EN)',
        dateOfIssue: 'Date of Issue',
        valid: 'Valid',
        noteEn: 'Note (EN)',
        productId: 'Product ID',
        expiration: 'Expiration',
      },
    },
    settings: {
      header: 'Integration Settings',
      page: {
        header: 'Integration Settings',
        error: 'Error loading integration settings',
        edit: 'Edit Integration Setting',
        create: 'Create Integration Setting',
      },
      newSetting: 'New Integration Setting',
      integrationType: 'Integration Type',
      baseUrl: 'Base URL',
      username: 'Username',
      password: 'Password',
      tenant: 'Tenant',
    },
  },
  subscription: {
    header: 'Subscription',
    page: {
      header: 'Subscription',
    },
    myList: {
      header: 'My Subscriptions',
      error: 'Error loading my subscriptions',
    },
    groupList: {
      header: 'Group Subscriptions',
      error: 'Error loading my group subscriptions',
    },
    create: {
      header: 'Create Subscription',
      success: 'Subscription created successfully',
      error: 'Error creating subscription',
    },
    edit: {
      header: 'Update Subscription',
      success: 'Subscription updated successfully',
      error: 'Error updating subscription',
    },
    delete: {
      header: 'Delete Subscription',
      success: 'Subscription deleted successfully',
      error: 'Error deleting subscription',
    },
    properties: {
      id: 'ID',
      createdBy: 'Created By',
      subscriberType: 'Subscriber Type',
      subscriberId: 'Subscriber ID',
      subscriberDisplayName: 'Subscriber',
      elementType: 'Element Type',
      elementId: 'Element ID',
      elementDisplayName: 'Element',
      channel: 'Channel',
      subscriptionType: 'Subscription Type',
      selectLegalProvision: 'Select Legal Provision',
      selectBundling: 'Select Bundling',
    },
  },
  signUp: {
    title: 'Sign Up',
    subtitle: 'Create your account',
    successMessage:
      'The account creation request created successfully! Please wait until one of our colleagues approves it.',
    form: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address',
      acceptTerms: 'I accept the Terms and Conditions',
      signUpButton: 'Sign Up with Azure',
      alreadyHaveAccount: 'Already have an account? Sign In',
    },
    validation: {
      requiredFirstName: 'First name is required',
      requiredLastName: 'Last name is required',
      requiredEmail: 'Email address is required',
      invalidEmail: 'Invalid email address',
      acceptTerms: 'You must accept the Terms and Conditions',
    },
    list: {
      approve: 'Approve',
      decline: 'Decline',
      pendingUsers: 'Pending Users',
    },
  },
  pendingUsers: {
    list: 'Pending Users',
    properties: {
      id: 'ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      login: 'Login',
      userType: 'User Type',
      userGroupName: 'User Group',
      approvalStatus: 'Approval Status',
    },
  },
  bundling: {
    header: 'Bundlings',
    list: {
      header: 'Bundlings',
    },
    edit: {
      header: 'Edit Bundling',
    },
    create: {
      header: 'Create Bundling',
    },
    properties: {
      title: 'Title',
      description: 'Description',
      strategy: 'Strategy',
      isPublic: 'Is Public',
      attributes: 'Attributes',
      bundlings: 'Bundlings',
      legalProvisions: 'Legal Provisions',
    },
    tabs: {
      legalProvisions: 'Legal Provisions',
      attributes: 'Attributes',
      bundlings: 'Bundlings',
    },
    childBundlings: 'Bundlings',
    confirmationDialog: {
      createBundling: {
        title: 'Create Bundling',
        content:
          'Are you sure you want to create the bundling? This will create all instances of this bundling accross the whole database.',
      },
      changeBundling: {
        title: 'Confirm Change Bundling',
        content:
          'Are you sure you want to change the bundling? This will change all instances of this bundling accross the whole database.',
      },
      deleteBundling: {
        title: 'Confirm Delete Bundling',
        content:
          'Are you sure you want to delete the bundling? This will delete all instances of this bundling accross the whole database.',
      },
    },
  },
  bundlings: {
    page: {
      header: 'Bundlings',
    },
  },
  legalProvisionBundling: {
    header: 'Legal Provision Bundling',
    list: {
      header: 'Legal Provision Bundlings',
    },
    edit: {
      header: 'Edit Legal Provision Bundling',
    },
    create: {
      header: 'Create Legal Provision Bundling',
    },
    properties: {
      isPublic: 'Is Public',
      bundlings: 'Bundling',
    },
    confirmationDialog: {
      changeBundling: {
        title: 'Confirm Change Bundling',
        content:
          'Are you sure you want to change the bundling? This will change all instances of this bundling accross the whole database.',
      },
      deleteBundling: {
        title: 'Confirm Delete Bundling',
        content:
          'Are you sure you want to delete the bundling? This will delete all instances of this bundling accross the whole database.',
      },
    },
  },
  attributes: {
    page: {
      header: 'Attributes',
    },
    list: {
      header: 'Attributes',
    },
    edit: {
      header: 'Edit Attribute',
    },
    create: {
      header: 'Create Attribute',
    },
    forms: {
      properties: {
        title: 'Title',
        description: 'Description',
        strategy: 'Strategy',
        isPublic: 'Is Public',
        parentAttribute: 'Parent Attribute',
      },
      edit: {
        success: 'Attribute edited successfully',
        failure: 'Failed to edit attribute',
      },
      create: {
        success: 'Attribute created successfully',
        failure: 'Failed to create attribute',
      },
      delete: {
        success: 'Attribute deleted successfully',
        failure: 'Failed to delete attribute',
      },
    },
  },
  access: {
    page: {
      header: 'Access',
    },
    list: {
      header: 'Regulation Access',
    },
    members: {
      header: 'Regulation Members',
      list: {
        title: 'Members List',
      },
    },
    create: {
      page: {
        header: 'Create Regulation Access',
      },
    },
  },
  organization: {
    page: {
      header: 'Organization',
    },
    list: {
      header: 'Organization List',
      tabs: {
        members: {
          title: 'Organization Member List',
        },
        groups: {
          title: 'Organization Group Member List',
        },
      },
    },
    members: {
      page: {
        header: 'Organization Members',
      },
      list: {
        title: 'Members List',
        firstName: 'First Name',
        lastName: 'Last Name',
        login: 'Login',
        role: 'Role',
      },
    },
    group: {
      page: {
        header: 'Organization Groups',
      },
      properties: {
        organizationGroupName: 'Group Name',
      },
    },
    groupMembers: {
      page: {
        header: 'Organization Group Members',
      },
      list: {
        title: 'Members List',
        firstName: 'First Name',
        lastName: 'Last Name',
        login: 'Login',
        role: 'Role',
      },
    },
    property: {
      name: 'Organization',
    },
  },
};

export default en;
